import cc from 'classcat';
import { jsx } from 'react/jsx-runtime';
import { svgCls } from './styles/svg.js';

const Triangle2Shape = ({
  fillColor = "currentColor",
  shapeRef,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  strokeColor,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx("svg", {
    ...svgProps,
    className: cc([svgCls, svgProps.className]),
    ref: shapeRef,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 324.2 370.4",
    fill: fillColor,
    children: /*#__PURE__*/jsx("path", {
      d: "M0 370.4h324.2L0 0z"
    })
  });
};

export { Triangle2Shape };
//# sourceMappingURL=Triangle2Shape.js.map
